export default __webpack_public_path__ + "static/media/coins.c62ca7c8.svg";